import { api } from '../api.js';
import { resolveDataTenantId } from '../utils/platformViewTenant.js';

export const getFarms = (params = {}) => {
  return api.get('/farms', { params: { tenantId: resolveDataTenantId(), ...params } });
};

export const createFarm = (data) => {
  const body = new URLSearchParams();
  body.set('tenantId', resolveDataTenantId());
  body.set('farmName', (data.farmName || '').trim());
  body.set('description', data.description || '');
  body.set('location', data.location || '');
  body.set('personInCharge', data.personInCharge != null ? String(data.personInCharge) : '');
  return api.post('/farms', body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

export const updateFarm = (id, data) => {
  const body = new URLSearchParams();
  if (data.farmName != null) body.set('farmName', data.farmName);
  if (data.description != null) body.set('description', data.description);
  if (data.location != null) body.set('location', data.location);
  if (data.personInCharge != null) body.set('personInCharge', data.personInCharge);
  return api.put(`/farms/${id}`, body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

export const deleteFarm = (id) => {
  return api.delete(`/farms/${encodeURIComponent(String(id))}`);
};

export const assignPlotToFarm = (assetId, farmId) => {
  const body = new URLSearchParams();
  body.set('assetId', assetId);
  body.set('farmId', farmId || '');
  return api.post('/farms/assign-plot', body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

/** 农场下已绘制地块（land_geometry）→ 灌溉设计地图多选区 JSON */
export const getFarmDrawnParcelGeometries = (farmId, assetIds = []) => {
  const ids = Array.isArray(assetIds)
    ? assetIds.map((x) => String(x || '').trim()).filter(Boolean)
    : [];
  return api.get(`/farms/${encodeURIComponent(String(farmId))}/drawn-parcel-geometries`, {
    params: ids.length ? { assetIds: ids.join(',') } : undefined
  });
};

/** 我的农场治理：归属率、待归属池、档案完备度、智能摘要与最近审计 */
export const getFarmGovernanceOverview = (params = {}) => {
  return api.get('/farms/governance/overview', {
    params: { tenantId: resolveDataTenantId(), auditLimit: 10, ...params }
  });
};

/** 治理：待归属地块绑定农场（记审计） */
export const assignParcelGovernance = ({ tenantId, parcelId, farmId, operatorName, remark }) => {
  const body = new URLSearchParams();
  body.set('tenantId', tenantId || resolveDataTenantId());
  body.set('parcelId', String(parcelId || '').trim());
  body.set('farmId', String(farmId || '').trim());
  if (operatorName) body.set('operatorName', String(operatorName).trim());
  if (remark) body.set('remark', String(remark).trim());
  return api.post('/farms/governance/assign-parcel', body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

/** 治理任务列表 */
export const getFarmGovernanceTasks = (params = {}) => {
  return api.get('/farms/governance/tasks', {
    params: { tenantId: resolveDataTenantId(), status: 'ALL', limit: 20, ...params }
  });
};

/** 从治理建议创建任务 */
export const createFarmGovernanceTask = ({ tenantId, taskType, title, ownerName, dueDate, detail, sourceIssue }) => {
  const body = new URLSearchParams();
  body.set('tenantId', tenantId || resolveDataTenantId());
  body.set('taskType', String(taskType || '').trim());
  body.set('title', String(title || '').trim());
  if (ownerName) body.set('ownerName', String(ownerName).trim());
  if (dueDate) body.set('dueDate', String(dueDate).trim());
  if (detail) body.set('detail', String(detail).trim());
  if (sourceIssue) body.set('sourceIssue', String(sourceIssue).trim());
  return api.post('/farms/governance/tasks', body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

/** 更新治理任务状态 */
export const updateFarmGovernanceTaskStatus = ({ tenantId, taskId, status, completedNote }) => {
  const body = new URLSearchParams();
  body.set('tenantId', tenantId || resolveDataTenantId());
  body.set('status', String(status || '').trim());
  if (completedNote) body.set('completedNote', String(completedNote).trim());
  return api.put(`/farms/governance/tasks/${encodeURIComponent(String(taskId))}/status`, body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};

/** 作物季治理对象列表 */
export const getFarmGovernanceCropSeasons = (params = {}) => {
  return api.get('/farms/governance/crop-seasons', {
    params: { tenantId: resolveDataTenantId(), limit: 20, ...params }
  });
};

/** 作物季绑定种植计划 */
export const bindFarmGovernanceCropSeasonPlan = ({ tenantId, archiveId, plantingPlanId }) => {
  const body = new URLSearchParams();
  body.set('tenantId', tenantId || resolveDataTenantId());
  body.set('plantingPlanId', String(plantingPlanId || '').trim());
  return api.post(`/farms/governance/crop-seasons/${encodeURIComponent(String(archiveId))}/bind-plan`, body.toString(), {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
};
